import { userAPI } from '../UserAPI';

/**
 * Öffnet eine Präsentation in PowerPoint. PowerPoint holt die Datei selbst, also ohne den
 * Authorization-Header und ohne das Datei-Session-Cookie des Portals — deshalb bekommt es einen
 * signierten Link (tri-server docs/documents-route-access.md). Scheitert das Signieren, geht der
 * unsignierte Link hinaus: Solange die Route im Beobachtungsmodus läuft, funktioniert er weiter.
 */
export const openInPowerPoint = async (url: string): Promise<void> => {
    let target = url;
    try {
        target = await userAPI.signFileLink(url);
    } catch {
        // unsignierter Link, siehe oben
    }
    window.location.href = powerPointHref(target);
};

export const powerPointHref = (url: string) => `ms-powerpoint:ofe|u|${url}`;
